import type {ComponentType} from 'react';

import loadable from '@loadable/component';
import React from 'react';
import {redirect, Route} from 'react-router-dom';

import getSharedLoader from '../lib/router/getSharedLoader';
import {linkToApp} from '../lib/url/linkToApp';
import About from './About';
import Community from './Community';
import CommunityRules from './CommunityRules';
import Contact from './Contact';
import Event from './Event';
import Events from './Events';
import FAQ from './FAQ';
import HomePage from './HomePage';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfUse from './TermsOfUse';

const MarketingLayout = loadable(() => import('../layouts/marketing'));

const MarketingRoutes = (
  <Route
    Component={MarketingLayout as ComponentType}
    loader={getSharedLoader({loadableRoot: MarketingLayout})}
    path="/"
  >
    <Route
      Component={HomePage as ComponentType}
      index={true}
      key="HomePage"
      loader={getSharedLoader({loadableRoot: HomePage})}
    />
    <Route
      Component={Events as ComponentType}
      key="Events"
      loader={getSharedLoader({loadableRoot: Events})}
      path="/event"
    />
    <Route
      Component={Event as ComponentType}
      key="Event"
      loader={getSharedLoader({loadableRoot: Event})}
      path="/event/:id"
    />
    <Route
      Component={About as ComponentType}
      key="About"
      loader={getSharedLoader({loadableRoot: About})}
      path="/about"
    />
    <Route
      Component={Community as ComponentType}
      key="Community"
      loader={getSharedLoader({loadableRoot: Community})}
      path="/community"
    />
    <Route
      Component={CommunityRules as ComponentType}
      key="CommunityRules"
      loader={getSharedLoader({loadableRoot: CommunityRules})}
      path="/community-rules"
    />
    <Route
      Component={FAQ as ComponentType}
      key="FAQ"
      loader={getSharedLoader({loadableRoot: FAQ})}
      path="/faq"
    />
    <Route
      Component={Contact as ComponentType}
      key="Contact"
      loader={getSharedLoader({loadableRoot: Contact})}
      path="/contact"
    />
    <Route
      Component={PrivacyPolicy as ComponentType}
      key="PrivacyPolicy"
      loader={getSharedLoader({loadableRoot: PrivacyPolicy})}
      path="/privacy-policy"
    />
    <Route
      Component={TermsOfUse as ComponentType}
      key="TermsOfUse"
      loader={getSharedLoader({loadableRoot: TermsOfUse})}
      path="/terms-of-use"
    />
    <Route
      key="login-redirect"
      loader={() => redirect(linkToApp('/login'))}
      path="/login"
    />
    <Route
      key="signup-redirect"
      loader={() => redirect(linkToApp('/signup'))}
      path="/signup"
    />
    <Route
      key="reset-password-redirect"
      loader={() => redirect(linkToApp('/reset-password'))}
      path="/reset-password"
    />
  </Route>
);

export default MarketingRoutes;
